import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=54ad0ffd&"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports